import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MailImg from '../../assets/images/Mail.png';
import { useSelector } from 'react-redux';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
`;

const ModalHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 56px;
  background: #44474F;
  color: #fff;
  font-family: 'Manrope', sans-serif;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  z-index: 10001;
`;

const ModalFooter = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  background: #fff;
  padding: 16px 32px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 10001;
`;

const ModalCard = styled.div`
  background: #F3F4F7;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  width: 640px;
  max-width: 95vw;
  padding: 0 0 32px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 80px auto 80px auto;
  position: relative;
  top: 56px;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
`;

const FooterButton = styled.button`
  background: #f3f4f7;
  color: #1b2028;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 14px;
  font-family: 'Manrope', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #e4e7ec;
  }
`;

const Logo = styled.img`
  width: 120px;
  margin: 32px auto 0 auto;
  display: block;
  height:44px;
  image-rendering: pixelated;
`;

const InnerCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ECECEC;
  box-shadow: 0px 10px 25px 0px #0000000D;
  margin-top: 24px;
  padding: 40px;
  width: 560px;
  max-width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const MailIcon = styled.img`
  width: 48px;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  font-family: 'Manrope', sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 24px 0;
  text-align: center;
`;

const EmailBody = styled.div`
  width: 100%;
  font-family: 'Manrope', sans-serif;
  font-size: 14px;
  color: #364151;
  margin-top: 8px;
  line-height: 1.7;
`;

const EmailPreviewModal = ({ open, onClose, emailBody, activeLabel }) => {
  const {companySettings} = useSelector((state) => state.home);
  const titleMap = {
    'External Share Email': 'External Share',
    'E-Signature Reminder Email': 'Signature Reminder',
    'E-Signature Request Email': 'Signature Request'
  };
  if (!open) return null;
  return (
    <ModalOverlay>
      <ModalHeader>
        <span>{activeLabel}</span>
        <CloseButton onClick={onClose} aria-label="Close">&times;</CloseButton>
      </ModalHeader>
      <ModalCard>
        <Logo src={companySettings.data.logo_url} alt="Logo" />
        <InnerCard>
          <MailIcon src={MailImg} alt="Mail Icon" />
          <Title>{titleMap[activeLabel]}</Title>
          <EmailBody dangerouslySetInnerHTML={{ __html: emailBody }} />
        </InnerCard>
      </ModalCard>
      <ModalFooter>
        <FooterButton onClick={onClose}>Close Preview</FooterButton>
      </ModalFooter>
    </ModalOverlay>
  );
};

EmailPreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  emailBody: PropTypes.string.isRequired,
  activeLabel: PropTypes.string.isRequired,
};

export default EmailPreviewModal; 